import { forwardRef } from '@chakra-ui/react';

import {
  Button,
  ButtonProps,
  OutlineCircleInfoIcon,
  useTheme,
} from '@frontend/components';

export const FindingPill = forwardRef<
  { isOpen?: boolean; strikethrough?: boolean } & ButtonProps,
  'button'
>(({ isOpen, strikethrough, children, ...props }, ref) => {
  const theme = useTheme();
  return (
    <Button
      className="finding-pill"
      ref={ref}
      size="sm"
      variant="secondary"
      borderRadius={`calc(${theme.sizes[1.5]} * 1)`}
      pl={1.25}
      pr={0.5}
      gap={0.5}
      textTransform="none"
      color="feature.primary"
      bg="page.plateLight"
      isActive={isOpen ? true : undefined}
      whiteSpace="normal"
      alignItems="flex-start"
      textAlign="start"
      justifyContent="flex-start"
      height="auto"
      textDecoration={strikethrough ? 'line-through' : undefined}
      _focus={{
        shadow: 'none',
      }}
      _focusVisible={{
        shadow: 'focus',
      }}
      _hover={{
        bg: 'interaction.surfaceHover',
        color: 'interaction.hover',
        borderColor: 'interaction.hover',
      }}
      _active={{
        bg: 'interaction.surfaceActive',
        color: 'interaction.active',
        borderColor: 'interaction.active',
      }}
      sx={{
        '.info-icon': {
          transitionProperty: 'common',
          transitionDuration: 'fast',
          color: 'feature.secondary',
        },
        '&:not([data-active]):hover .info-icon': {
          color: 'interaction.hover',
        },
        '&[data-active] .info-icon': {
          color: 'interaction.active',
        },
      }}
      {...props}
    >
      {children}
      <OutlineCircleInfoIcon className="info-icon" size={2} my={0.25} />
    </Button>
  );
});
